import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["abbreviate", "abbreviateThreshold", "value", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode", "formatNegativeValuesWithParenthesis"];
import { useContext } from 'react';
import I18n from 'I18n';
import formatCurrencyWithCode from '../utils/formatCurrencyWithCode';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Import from 'I18n/components/FormattedIntlCurrency' instead
 */
function FormattedCurrency(t0) {
  const {
      abbreviate,
      abbreviateThreshold,
      value,
      simplifyCurrency: t1,
      stripInsignificantZeros: t2,
      useCurrencyCode,
      formatNegativeValuesWithParenthesis: t3
    } = t0,
    options = _objectWithoutPropertiesLoose(t0, _excluded);
  const simplifyCurrency = t1 === undefined ? false : t1;
  const stripInsignificantZeros = t2 === undefined ? false : t2;
  const formatNegativeValuesWithParenthesis = t3 === undefined ? false : t3;
  useContext(I18nHMRContext);
  options.formatNegativeValuesWithParenthesis = formatNegativeValuesWithParenthesis;
  if (simplifyCurrency && value % 1 === 0) {
    options.precision = 0;
  }
  if (useCurrencyCode) {
    options.unit = "";
    options.useCurrencyCode = true;
  }
  if (stripInsignificantZeros === false) {
    options.strip_insignificant_zeros = false;
  } else {
    options.strip_insignificant_zeros = true;
  }
  const wrapperAttributes = {};
  if (abbreviate && (typeof abbreviateThreshold !== "number" || typeof abbreviateThreshold === "number" && value >= abbreviateThreshold)) {
    wrapperAttributes.title = I18n.formatCurrency(value, options);
    options.abbreviate = true;
    options.precision = 0;
  }
  const formattedNumber = I18n.formatCurrency(value, options);
  const numberToRender = useCurrencyCode ? formatCurrencyWithCode(formattedNumber, options.currencyCode) : formattedNumber;
  return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
    children: numberToRender
  }));
}
FormattedCurrency.displayName = 'FormattedCurrency';
export default FormattedCurrency;